import { styled } from "styled-components";

const LayoutWrapper = styled.div`
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.surfacePrimary};
`;

const Main = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  flex: 1;
`;

const Background = styled.div<{ $hasNFT: boolean }>`
  position: absolute;

  top: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    ${({ $hasNFT }) => ($hasNFT ? 0 : 180)}deg,
    rgba(219, 115, 255, 0.5) 0%,
    rgba(255, 225, 118, 0.5) 100%
  );
  opacity: 0.5;
  pointer-events: none;
  transition: background-color 0.5s linear;
`;

export default {
  LayoutWrapper,
  Main,
  Background,
};
